// extracted by mini-css-extract-plugin
export default {"appLayout":"app_appLayout","header":"app_header","mainList":"app_mainList"};